module.exports = __webpack_public_path__ + "static/media/waves-2-pn.72b92a0a.svg";